/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, total: NonNullable<unknown> }} Usage_Tab_Pages_CountInputs */



/**
* | output |
* | --- |
* | "{used} of {total} pages this month" |
*
* @param {Usage_Tab_Pages_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_pages_count = /** @type {((inputs: Usage_Tab_Pages_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_Pages_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.used} von ${i?.total} Seiten diesen Monat`)
	return /** @type {LocalizedString} */ (`${i?.used} of ${i?.total} pages this month`)
});